import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

export default function ({ items }) {
    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                border={0}

            >
                <Typography>Expandir</Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0">
                <table className="table table-sm m-0">
                    <thead>
                        <tr>
                            <th scope="col">Linha</th>
                            <th scope="col">CustCode</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(e => <tr>
                            <td>{e.linha}</td>
                            <td>{e.custCode}</td>
                        </tr>)}
                    </tbody>
                </table>
            </AccordionDetails>
        </Accordion>);
}